export default __webpack_public_path__ + "static/media/test-facebook.d44bb8fb.svg";